import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import Tooltip from '@mui/material/Tooltip';
import { AuthGuard } from './AuthGuard';

interface GridActionProps {
  onEdit?: (row: any, event: any) => void;
  onDeleted?: (id: string, event: any) => void;
  row: any;
  id: string;
  children?: React.ReactNode;
  editPermission?: string;
  deletePermission?: string;
  isDisabled?: boolean;
}

export default function GridAction(props: GridActionProps) {
  return (
    <>
      <>
        {props.onEdit && <AuthGuard permission={props.editPermission}>
          <Tooltip title='Edit' disableInteractive style={{ cursor: 'pointer' }}>
            <EditNoteRoundedIcon fontSize='small' onClick={(e) => !props.isDisabled && props.onEdit && props.onEdit(props.row, e)} />
          </Tooltip>
        </AuthGuard>}
      </>{' '}
      <>
        {props.onDeleted && <AuthGuard permission={props.deletePermission}>
          <Tooltip title='Delete' disableInteractive style={{ cursor: 'pointer' }}>
            <DeleteForeverOutlinedIcon fontSize='small' onClick={(e) => !props.isDisabled && props.onDeleted && props.onDeleted(props.id, e)} />
          </Tooltip>
        </AuthGuard>}
      </>
      {props.children}
    </>
  );
}
